import React, { Fragment, useEffect, useState } from 'react';
import compose from 'recompose/compose';
import { getI18n } from '../../../../utils/intl';
import { useIntl } from 'react-intl';

import {
  getCertListError,
  getAddCertStatus,
  getCertValidationErrors,
  getCertDeleteStatus,
} from '../../../../reducers/application';

import {
  addAppCertificate,
  deleteAppCertificate,
  resetAppCertStatus,
} from '../../../../actions/application';
import { Button, Dialog, Grid, Link, withStyles } from '@material-ui/core';
import { connect } from 'react-redux';
import styles from './styles';
import ListContainer from '../../../list';
import { cloneDeep, get, toLower } from 'lodash';
import moment from 'moment';
import { arrayOf, bool, func, shape, string } from 'prop-types';
import AddCertificate from './AddCertificate';
import { ALERT_ERROR, ALERT_SUCCESS } from '../../../../constants';
import { getFirstValidationError } from '../../../../utils';
import { FilterByText, SortBySelect } from '../../../../pageComponents';
import { getCertificateExpiryStatus } from './utils';
export const Certificates = (props) => {
  const {
    classes,
    certList,
    appUuid,
    validationErrors,
    addCertStatus,
    deleteCertStatus,
    isCertListError,
    workFlowMode,
    apiKeySettings,
    locked,
    isRoleAllowedToAddDelete,
  } = props;
  const { getI18nMessage } = getI18n(useIntl());
  const [rowsList, setRowsList] = useState([]);
  const [isAddCertDialogOpen, setIsAddCertDialogOpen] = useState(false);
  const [notificationStatus, setNotificationStatus] = useState('');
  const [notificationMessage, setNotificationMessage] = useState('');
  const [deletingCertUuid, setDeletingCertUuid] = useState('');
  const [nameFilter, setNameFilter] = useState('');
  const [subjectDomainFilter, setSubjectDomainFilter] = useState('');
  const [sortFieldValue, setSortFieldValue] = useState('expiryTs_ASC');
  useEffect(() => {
    if(appUuid) {
      props.fetchAppCertificates(appUuid);
    }
  },[]);
  useEffect(() => {
    if(certList) {
      const certListCopy = cloneDeep(certList);
      setRowsList(certListCopy.sort((a, b) => a.expiryTs - b.expiryTs));
    }
  },[certList]);
  useEffect(() => {
    if(addCertStatus === 'SUCCESS') {
      setIsAddCertDialogOpen(false);
      notifyMessages(getI18nMessage(`label.application.details.certificates.add.${workFlowMode ? 'request.' : ''}success`), ALERT_SUCCESS);
      props.fetchAppCertificates(appUuid);
      if(workFlowMode) {
        props.fetchApplication(appUuid);
      }
      setTimeout(() => notifyMessages('', ''), 2500);
    }
  },[addCertStatus]);
  useEffect(() => {
    if(deleteCertStatus === 'SUCCESS') {
      notifyMessages(getI18nMessage(`label.application.details.certificates.delete.${workFlowMode ? 'request.' : ''}success`), ALERT_SUCCESS);
      if(workFlowMode) {
        props.fetchApplication(appUuid);
      }
      props.fetchAppCertificates(appUuid);
      setDeletingCertUuid('');
      setTimeout(() => notifyMessages('', ''), 2500);
    } else if(deleteCertStatus === 'ERROR') {
      const errorMessage = getFirstValidationError(validationErrors,
        getI18nMessage(`label.application.details.certificates.delete.${workFlowMode ? 'request.' : ''}failed`));
      notifyMessages(errorMessage, ALERT_ERROR);
      props.fetchAppCertificates(appUuid);
    }
  }, [deleteCertStatus]);
  useEffect(() => {
    if(isCertListError) {
      notifyMessages(getI18nMessage('label.application.details.certificates.list.failed'), ALERT_ERROR);
    }
  },[isCertListError]);
  const getExpiryDateText = (expiryTs) => {
    let expiryDateText = 'None';
    if (expiryTs) {
        const expiryDate = moment(expiryTs);
        expiryDateText = expiryDate.format(
          'MMM Do YYYY, HH:mm',
        );
    }
    return expiryDateText;
  };
  const notifyMessages = (message, status) => {
    setNotificationStatus(status);
    setNotificationMessage(message);
  };

  const startReportingDays = get(apiKeySettings, 'startReportingBeforeDays', 90);
  const urgentReportingDays = get(apiKeySettings, 'reportAsUrgentBeforeDays', 60);
  
  const deleteCert = (uuid) => {
    props.deleteAppCertificate(appUuid, uuid);
  };
  const formatDeleteWidget = (uuid) => (
    <div className={classes.deleteAction}>
      {deletingCertUuid === uuid ?
        <div>
          <Link className={classes.deleteLink} onClick={() => deleteCert(uuid)} underline='none'>
            {getI18nMessage('label.application.details.certificates.delete.confirm.link')}
          </Link>
          <Link className={classes.cancelLink} onClick={() => setDeletingCertUuid('')} underline='none'>
            {getI18nMessage('label.application.details.certificates.delete.cancel.link')}
          </Link>
        </div> :
        <Link className={classes.deleteLink} onClick={() => !locked && setDeletingCertUuid(uuid)} underline='none' disabled={locked}>
          {getI18nMessage(`label.application.details.certificates.delete.${workFlowMode ? 'request.' : ''}link`)}
        </Link>
      }
    </div>
  );
  const applyFilter = () => {
    setRowsList(certList.filter(cert => {
      const qualifiedForName = !nameFilter ||
            (cert.name && toLower(cert.name).includes(toLower(nameFilter)));
      const qualifiedForSDN = !subjectDomainFilter ||
            (cert.subjectName && toLower(cert.subjectName).includes(toLower(subjectDomainFilter)));
      return qualifiedForName && qualifiedForSDN;
    }));
  };

  const CERTIFICATES_LIST_SORT_BY = [
    {
      uuid: 'expiryTs_ASC',
      text: getI18nMessage('label.application.details.certificates.sort.expiry.asc'),
    }, {
      uuid: 'expiryTs_DESC',
      text: getI18nMessage('label.application.details.certificates.sort.expiry.desc'),
    }, {
      uuid: 'name_ASC',
      text: getI18nMessage('label.application.details.certificates.sort.name.asc'),
    }, {
      uuid: 'name_DESC',
      text: getI18nMessage('label.application.details.certificates.sort.name.desc'),
    },
  ];
  const onSortByChange = (val) => {
    setSortFieldValue(val);
    const rowsListCopy = cloneDeep(rowsList);
    switch(val) {
      case 'expiryTs_DESC':
        setRowsList(rowsListCopy.sort((a, b) => b.expiryTs - a.expiryTs));
        break;
      case 'expiryTs_ASC':
        setRowsList(rowsListCopy.sort((a, b) => a.expiryTs - b.expiryTs));
        break;
      case 'name_ASC':
        setRowsList(rowsListCopy.sort((a, b) => a.name > b.name ? 1 : -1));
        break;
      case 'name_DESC':
        setRowsList(rowsListCopy.sort((a, b) => b.name > a.name ? 1 : -1));
        break;
    }
  };
  const getCertificateListColumns = () => {
    const columns = [{
      id: 'name',
      label: getI18nMessage('label.application.details.certificates.column.certificate'),
      value: ({ name }) => name,
    },{
      id: 'subjectName',
      label: getI18nMessage('label.application.details.certificates.column.subject'),
      minwidth: 100,
      value: ({ subjectName }) => subjectName,
    },{
      id: 'thumbPrintSha256',
      label: getI18nMessage('label.application.details.certificates.column.thumbprint'),
      minwidth: 100,
      value: ({ thumbPrintSha256 }) => thumbPrintSha256,
    },{
      id: 'expiryTs',
      label: getI18nMessage('label.application.details.certificates.column.valid.not.after', { zone: moment.tz(moment.tz.guess()).zoneAbbr() }),
      minwidth: 100,
      value: ({ expiryTs }) => getExpiryDateText(expiryTs),
    },{
      id: 'daysToExpiry',
      label: getI18nMessage('label.application.details.certificates.column.days.to.expiry'),
      minwidth: 100,
      value: ({ expiryTs, uuid }) =>
              getCertificateExpiryStatus(
                expiryTs, uuid, classes, startReportingDays, urgentReportingDays),
    }];
    if(isRoleAllowedToAddDelete) {
      columns.push({
        id: 'action',
        label: getI18nMessage('label.application.details.certificates.column.days.to.action'),
        minwidth: 100,
        value: ({ uuid }) => formatDeleteWidget(uuid),
      });
    }
    return columns;
  }

  return (
    <>
      <Dialog
          open={isAddCertDialogOpen}
          onClose={() => { props.resetAppCertStatus(); setIsAddCertDialogOpen(false); }}
          aria-labelledby="add-cert-dialog"
          id="add-certificate-dialog"
          classes={{
            paper: classes.paperClass,
          }}
        >
          <AddCertificate
            addAppCertificate={props.addAppCertificate}
            appUuid={appUuid}
            addCertStatus={addCertStatus}
            validationErrors={validationErrors}
            onClose={() => { props.resetAppCertStatus(); setIsAddCertDialogOpen(false); }}
            workFlowMode={workFlowMode}
          />
      </Dialog>
      <ListContainer
        listPageId="app-api-apiplan-dialog"
        columns={getCertificateListColumns()}
        rows={rowsList}
        noResultsMessage={getI18nMessage('label.application.details.certificates.no.results')}
        pageBodyClass={classes.pageBodyClass}
        pageClass={classes.pageClass}
        hasPaginationDisabled={true}
        notificationStatus={notificationStatus}
        notificationMessage={notificationMessage}
        setNotificationMessage={setNotificationMessage}
        setNotificationStatus={setNotificationStatus}
        hidePagination
        hideFooter
        filterAndSortContent={(
          <Fragment>
            <Grid item md={2} sm={3} xs={12}>
              <FilterByText
                id="category-filter-by-name"
                fieldContainerClass={classes.nameContainer}
                name={getI18nMessage('label.filter')}
                value={nameFilter}
                placeholder={getI18nMessage('label.application.details.certificates.filters.name.placeholder')}
                handleChange={val => setNameFilter(val)}
                handleBlur={applyFilter}
              />
            </Grid>
            <Grid item md={2} sm={3} xs={12} className={classes.noTitleGrid}>
              <FilterByText
                id="category-filter-by-name"
                fieldContainerClass={classes.nameContainer}
                value={subjectDomainFilter}
                placeholder={getI18nMessage('label.application.details.certificates.filters.subject.domain.placeholder')}
                handleChange={val => setSubjectDomainFilter(val)}
                handleBlur={applyFilter}
              />
            </Grid>
            <Grid item md={3} sm={0} xs={0} />
            <Grid item md={2} sm={3} xs={12} className={classes.sortContainer}>
              <SortBySelect
                fieldContainerClass={classes.fieldContainer}
                name={getI18nMessage('label.sort')}
                selectFieldClass={classes.selectField}
                value={sortFieldValue}
                data={CERTIFICATES_LIST_SORT_BY}
                handleChange={onSortByChange}
              />
            </Grid>
            <Grid item md={2} sm={3} xs={12} className={classes.noTitleGrid}>
              {isRoleAllowedToAddDelete &&
                <Button
                  className={classes.addBtn}
                  data-apim-test={'app-certs-add'}
                  data-layer7-test={'app-certs-add'}
                  id={'app-certs-add'}
                  onClick={() => setIsAddCertDialogOpen(true)}
                  variant="contained" color="secondary"
                  disabled={locked}
                >
                  {getI18nMessage('label.application.details.certificates.add.certificate')}
                </Button>
              }
            </Grid>
          </Fragment>
        )}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  isCertListError: getCertListError(state),
  addCertStatus: getAddCertStatus(state),
  validationErrors: getCertValidationErrors(state),
  deleteCertStatus: getCertDeleteStatus(state),
});
Certificates.displayName = 'ApplicationCertificates';
const mapDispatchToProps = {
  addAppCertificate,
  deleteAppCertificate,
  resetAppCertStatus,
}

Certificates.propTypes = {
  classes: shape({}),
  certList: arrayOf(shape({})),
  isCertListError: bool,
  appUuid: string,
  fetchAppCertificates: func,
  addAppCertificate: func,
  deleteAppCertificate: func,
  workFlowMode: bool,
  deleteCertStatus: string,
  addCertStatus: string,
  validationErrors: arrayOf(shape({})),
  resetAppCertStatus: func,
  apiKeySettings: shape({}),
  locked: bool,
  isRoleAllowedToAddDelete: bool,
  fetchApplication: func,
}
export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps),
)(Certificates);